import { Row, Col } from "antd"
import { Steps } from "../steps"

export function Subheader({ title, actions, currentStepKey, stepsToOmit }) {
  return (
    <Row align="middle">
      <Col flex={2} className="ant-page-header-heading-title">{title}</Col>
      <Col flex={2}><Steps currentStepKey={currentStepKey} stepsToOmit={stepsToOmit} /></Col>
      <Col flex={2}><div className="float-right">{actions}</div></Col>
    </Row>
  )
}
